import { Layout } from '@app/layouts/user';

export default Layout;
